// extracted by mini-css-extract-plugin
var _1 = "EmailProfileWidgetCustomFolders-modulewidget__jhPBb Widget-moduleWidget__bcnWB";
export { _1 as "widget" }
